import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from '../utils/chartUtils';

const EnergyChart = ({ chartData, timeRangeType }) => {
  const xAxisProps = {
    dataKey: "displayTime",
    angle: 0,
    textAnchor: timeRangeType === 'today' ? "end" : "end",
    height: 80,
    interval: "preserveStartEnd",
    tick: { fontSize: timeRangeType === 'today' ? 12 : 11 }
  };

  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis {...xAxisProps} />
        <YAxis label={{ value: 'kcal', angle: -90, position: 'insideLeft' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar
          dataKey="active_energy"
          fill="#ffc107"
          radius={[4, 4, 0, 0]}
          barSize={timeRangeType === 'today' ? 40 : 25}
          name="Active Energy"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default EnergyChart;